'use strict';

angular.module('randomization')
    .filter('randomizationStockState', ['gettext', function (gettext) {
        return function (data) {
            var mapping = {
                assigned: gettext('Asignado'),
                cancelled: gettext('Anulado'),
                pending: gettext('Libre'),
                locked: gettext('En cuarentena'),
            };

            return data in mapping ? mapping[data] : data;
        };
    }]);
